<template>
    <div class="subtag-form">
        <!-- <span
            class="remove"
            @click="removeSubTag()"
        >
            &times;
        </span>

        <label>
            Subtag Title

            <input
                type="text"
                v-model="subtag.tagname"
                maxlength="16"
                @input="$emit('input-title',subtag)"
                @blur="validate($event.target.value)"
            >

            <span>{{`${16-subtag.tagname.length}/16`}}</span>
        </label>

        <custom-file-input
            label="Select or drop to upload media"
            :is-loading="subtag.loading"
            :progress="subtag.progress"
            :allowed-extensions="['jpg','png']"
            @input="$emit('input-image', subtag)"
            v-model="subtag.image"
            @remove="removeImage()"
            @warning="$emit('warning', $event)"
        ></custom-file-input> -->
    </div>
</template>

<script>
// import CustomFileInput from '@/components/utils/CustomFileInput.vue'

export default {
	components: {
		// CustomFileInput
	},

	props: {
		id: {
			type: Number,
			default: 0
		},

		tagname: {
			type: String,
			default: ''
		},

		image: {
			type: File || Object,
			default: () => {}
		},

		progress: {
			type: Number,
			default: 0
		},

		serverName: {
			type: String,
			default: ''
		},

		loading: {
			type: Boolean,
			default: false
		}
	},

	watch: {
		id (val) {
			this.subtag.id = val
		},

		title (val) {
			this.subtag.title = val
		},

		image (val) {
			this.subtag.image = val
		},

		progress (val) {
			this.subtag.progress = val
		},

		loading (val) {
			this.subtag.loading = val
		},
		serverName (val) {
			this.subtag.serverName = val
		}
	},

	data () {
		return {
			subtag: {
				id: this.id,
				tagname: this.tagname,
				image: this.image,
				progress: this.progress,
				loading: this.loading,
				serverName: this.serverName
			}
		}
	},

	methods: {
		removeImage () {
			this.subtag.tagname = ''
			this.subtag.image = null
			this.subtag.serverName = null
			this.subtag.progress = 0
			this.$emit('input-image', this.subtag)
		},

		removeSubTag () {
			this.subtag.tagname = ''
			this.subtag.image = null
			this.subtag.serverName = null
			this.subtag.progress = 0
			this.$emit('remove')
		},

		validate (e) {
			console.log(e) // check if already exist ,
			// if exists
			// this.subtag.tagname='',
			// this.$emit('input', subtag)
		}
	}
}
</script>

<style lang="scss" scoped>
.subtag-form {
    border: 1px solid $light;
    padding: 20px;
    position: relative;

    .remove {
        position: absolute;
        right: 10px;
        top: 5px;
        font-size: 24px;
        cursor: pointer;
        color: $danger;
    }

    label {
        font-weight: 600;
        margin-bottom: 15px;
        display: block;
        font-size: 18px;

        input[type=text] {
            margin-top: 10px;
            display: block;
            width: 100%;
        }

        span {
            font-size: 12px;
            display: block;
            text-align: right;
            font-weight: 400;
            margin-top: 5px;
        }
    }

    .file-input-container {
        height: 200px;
    }
}
</style>
